import React, { useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { Container, Grid } from '@mui/material';
import EirOfferCardContainer from '../eir-offer-card/EirOfferCardContainer';
// import styles from '../eir-mobile-offer-toggle/styles';
import { MobileOfferContext } from '../eir-mobile-offer-container/mobile.context';

const StandaloneOfferCardContainer = ({
  offers,
  discounts,
  loading,
  onOfferSelect,
  onOfferUnSelect,
  addingTariff,
  selectedBundle,
  simOnly = false,
  showLoader,
  isStandAloneHandset,
}) => {
  // const theme = useTheme();

  // const [state, dispatch] = useReducer(mobileOfferReducer, initialState);
  const [state, setState] = useState({ simOnly });
  const [discountedOffers, setDiscountedOffers] = useState([]);

  useEffect(() => {
    // check if broadband is in cart or not, and reducing price
    if (discounts?.length > 0 && offers.length > 0) {
      let tempOffers = [...offers];
      const offerDiscount = discounts?.length > 0 ? discounts[0].value / 100 : 0;
      const formatAfterPrice = afterPrice => {
        let newAfterPrice = '';
        const pricePattern = /([\d.]+)/;
        const match = afterPrice.match(pricePattern);
        if (match) {
          newAfterPrice = afterPrice.replace(
            pricePattern,
            (parseFloat(match[1]) - offerDiscount).toFixed(2)
          );
        } else newAfterPrice = afterPrice;
        return newAfterPrice;
      };
      tempOffers = tempOffers.map(item => ({
        ...item,
        price: (item.price - offerDiscount).toFixed(2),
        afterPrice: formatAfterPrice(item.afterPrice),
      }));
      setDiscountedOffers(tempOffers);
    } else setDiscountedOffers(offers);
  }, [offers]);

  return (
    <MobileOfferContext.Provider value={{ state, setState }}>
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <EirOfferCardContainer
              offers={discountedOffers}
              loading={loading}
              onOfferSelect={onOfferSelect}
              onOfferUnSelect={onOfferUnSelect}
              addingTariff={addingTariff}
              selectedBundle={selectedBundle}
              showLoader={showLoader}
              isStandAloneHandset={isStandAloneHandset}
            />
          </Grid>
        </Grid>
      </Container>
    </MobileOfferContext.Provider>
  );
};

export default StandaloneOfferCardContainer;
